// Barrel do slice de getters do modulo de tarefas.
//
// `store/index.js` faz `import * as g from './getters'` e espalha o resultado
// em `getters`, entao TUDO que sai daqui vira um getter Vuex. Por isso o
// barrel reexporta apenas os modulos publicos — os helpers privados ficam em
// `getters-internal.js` e a maquinaria de ordenacao em `getters-sort.js`, que
// NAO sao reexportados.
export * from './getters-projection'
export * from './getters-slices'
export * from './getters-folders'
